var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('p',{staticClass:"text-black"},[_vm._v("\n        Calendário\n      ")])])],1),_vm._v(" "),_c('v-card',{attrs:{"rounded":"sm"}},[_c('Calendar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }